import { Button, RefBool } from "@tblabs/truffle";
import { Svg } from "../../Pages/Components/Utils/Svg";


export class CloseBasketButton extends Button
{
    constructor(showMiniBasket: RefBool)
    {
        super("");

        this.Class("cart-summary__close").Attribute("aria-label", "Zamknij koszyk")
            .Append(
                new Svg(`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x cart-summary__close-icon">
            <path d="M18 6 6 18"></path>
            <path d="m6 6 12 12"></path>
        </svg>`)
            )
            .OnClick(() => showMiniBasket.False());
    }
}
